import Immutable from 'immutable';

import ErrorData from 'sharedreact/data/ErrorData';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

import OpenIDConfig from 'workspaces/launcher/data/OpenIDConfig';

type OnFetchSuccess = (openIDConfig: Immutable.List<OpenIDConfig>) => void;
type OnFetchError = (error: ErrorData) => void;
type OnSaveOpenIDConfigSuccess = (openIDConfig: OpenIDConfig) => void;
type onRemoveSuccess = (ids: Immutable.Set<string>) => void
type OnError = (error: ErrorData) => void;

function fetch (onSuccess: OnFetchSuccess, onError: OnFetchError): void {
  ConnectionSupport.post(
    'getOpenIDConfigs',
    {},
    (data) => onSuccess(Immutable.List(data.items.map((item: object) => OpenIDConfig.fromJS(item)))),
    onError
  );
}

function save (openIDConfig: OpenIDConfig, onSuccess: OnSaveOpenIDConfigSuccess, onError: OnError): void {
  ConnectionSupport.post(
    'saveOpenIDConfig',
    {item: openIDConfig},
    (data) => onSuccess(OpenIDConfig.fromJS(data)),
    onError
  );
}

function remove (ids: Immutable.Set<string>, onSuccess: onRemoveSuccess, onError: OnError): void {
  ConnectionSupport.post(
    'removeOpenIDConfig',
    {ids: ids},
    (data) => onSuccess(Immutable.Set<string>(data.ids)),
    onError
  );
}

const OpenIDConfigConnection = {
  fetch,
  save,
  remove
};

export default OpenIDConfigConnection;